"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCollapsedMode = exports.useCurrentBreakpoint = exports.useWidth = exports.useBreakpointValues = exports.useTheme = void 0;
const lodash_throttle_1 = __importDefault(require("lodash.throttle"));
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const window_or_global_1 = __importDefault(require("window-or-global"));
const clientUtils_1 = require("../utils/clientUtils");
const useTheme = () => {
    const themeContext = (0, react_1.useContext)(styled_components_1.ThemeContext) || {};
    return themeContext;
};
exports.useTheme = useTheme;
const useBreakpointValues = () => {
    const theme = (0, exports.useTheme)();
    const breakpoints = (theme.breakpoints || {});
    const values = breakpoints.values || {};
    return values;
};
exports.useBreakpointValues = useBreakpointValues;
const useSsrSafeWidth = () => {
    const values = (0, exports.useBreakpointValues)();
    let width = values.lg;
    if (window_or_global_1.default.__server_side_render) {
        //SSR assume sm
        width = values.sm;
    }
    else {
        width = (0, clientUtils_1.getInnerWidth)();
    }
    return width;
};
const useWidth = () => {
    const initWidth = useSsrSafeWidth();
    const [clientWidth, setClientWidth] = (0, react_1.useState)(initWidth);
    const getWidth = (0, react_1.useCallback)(() => {
        const width = (0, clientUtils_1.getInnerWidth)();
        setClientWidth(width);
    }, [setClientWidth, clientUtils_1.getInnerWidth]);
    const throttleGetWidth = (0, lodash_throttle_1.default)(getWidth, 50);
    (0, react_1.useEffect)(() => {
        throttleGetWidth();
        window_or_global_1.default.addEventListener("resize", throttleGetWidth);
        return () => {
            throttleGetWidth.cancel();
            window_or_global_1.default.removeEventListener("resize", throttleGetWidth);
        };
    }, [throttleGetWidth]);
    return clientWidth;
};
exports.useWidth = useWidth;
const useCurrentBreakpoint = () => {
    const clientWidth = (0, exports.useWidth)();
    const values = (0, exports.useBreakpointValues)();
    const [finalBreakpointWidth, setFinalBreakpointWidth] = (0, react_1.useState)("unset");
    (0, react_1.useEffect)(() => {
        if (clientWidth) {
            if (clientWidth < values.sm) {
                setFinalBreakpointWidth("xs");
            }
            else if (clientWidth >= values.sm && clientWidth < values.md) {
                setFinalBreakpointWidth("sm");
            }
            else if (clientWidth >= values.md && clientWidth < values.lg) {
                setFinalBreakpointWidth("md");
            }
            else if (clientWidth >= values.lg && clientWidth < values.xl) {
                setFinalBreakpointWidth("lg");
            }
            else if (clientWidth >= values.xl) {
                setFinalBreakpointWidth("xl");
            }
        }
    }, [clientWidth]);
    return finalBreakpointWidth;
};
exports.useCurrentBreakpoint = useCurrentBreakpoint;
//Only render collapsed on the client to prevent hydration issues
const useCollapsed = (currentBreakpointWidth) => {
    const [collapsed, setCollapsed] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        setCollapsed(currentBreakpointWidth === "lg");
    }, [currentBreakpointWidth, setCollapsed]);
    return collapsed;
};
const useCollapsedMode = () => {
    const currentBreakpointWidth = (0, exports.useCurrentBreakpoint)();
    const collapsed = useCollapsed(currentBreakpointWidth);
    return collapsed;
};
exports.useCollapsedMode = useCollapsedMode;
//# sourceMappingURL=breakpoints.hooks.js.map